import {
  ApolloClient,
  createHttpLink,
  InMemoryCache
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { tokenKey } from '../context/AuthContext';

// ----------------------------------------------------------------------------

export type Client = ApolloClient<any>

export const createClient = (): Client => {
  const authLink = setContext((_, { headers }) => {
    let token;

    try {
      token = localStorage.getItem(tokenKey);
    } catch (error) {
      token = undefined;
    }

    let authHeaders = Boolean(token)
    ? {
        Authorization: `Bearer ${token}`,
      }
    : { 'x-hasura-admin-secret': process.env.REACT_APP_FSOS_PASS };
    return {
      headers: {
        ...headers,
        'content-type': 'application/json',
        ...authHeaders
      }
    };
  });

  const link = createHttpLink({
    uri: 'https://api.fsos.app/v1/graphql'
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(link),
    defaultOptions: { watchQuery: { fetchPolicy: "cache-and-network" } },
  });
};
